import { memo } from 'react';

import Button from '../common/button';
import Modal from '../common/modal';
import TableWithActions from '../common/table/table-with-actions';
import { useLogic } from './define-file-upload.logic';
import { IProps } from './define-file-upload.type';
const DefineFileUploadModal = (props: IProps) => {
	const { visible } = props;
	const {
		t,
		uploadColumns,
		uploadFiles,
		handleCompleteUpload,
		onCloseWithConfirm,
		allCompleted,
	} = useLogic(props);

	return (
		<Modal
			title={t('file-upload')}
			open={visible}
			onCancel={onCloseWithConfirm}
			width={600}
		>
			<div>
				<TableWithActions
					actionHidden
					columns={uploadColumns}
					dataSource={uploadFiles}
					rowKey={'id'}
					pagination={false}
					containerClassName="px-0"
					scroll={{ y: 600 }}
				/>
				{allCompleted && (
					<div className="flex justify-center mt-4">
						<Button type="primary" onClick={handleCompleteUpload} isMainBtn>
							{t('complete')}
						</Button>
					</div>
				)}
			</div>
		</Modal>
	);
};

export default memo(DefineFileUploadModal);
